import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
    return (
        <div className="crm-page flex flex-col items-center justify-center gap-2 p-8 text-center min-h-[240px]">
            <h1 className="text-base font-semibold text-foreground m-0">Page not found</h1>
            <p className="text-sm text-muted-foreground m-0">
                The page you requested does not exist.
            </p>
            <Link to="/deals" className="text-sm text-primary hover:underline mt-2">
                Go to Deals
            </Link>
        </div>
    );
}
